module.exports = __webpack_public_path__ + "static/media/Chinthan.b5ee16c0.svg";